/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.REFRESH = exports.PREV_PAGE = exports.NEXT_PAGE = exports.LAST_PAGE = exports.FIRST_PAGE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var emptyObject = {};
var SIZE = 20;
var getIcons = function getIcons() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyObject,
    size = _ref.size,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  size = size || SIZE;
  var FIRST_PAGE = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
    height: size,
    viewBox: "0 0 24 24",
    width: size
  }), _react.default.createElement("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
  }));
  var LAST_PAGE = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
    height: size,
    viewBox: "0 0 24 24",
    width: size
  }), _react.default.createElement("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
  }));
  var PREV_PAGE = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
    height: size,
    viewBox: "0 0 24 24",
    width: size
  }), _react.default.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  }));
  var NEXT_PAGE = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
    height: size,
    viewBox: "0 0 24 24",
    width: size
  }), _react.default.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }));
  var REFRESH = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
    height: size,
    viewBox: "0 0 24 24",
    width: size
  }), _react.default.createElement("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
  }));
  return {
    FIRST_PAGE: FIRST_PAGE,
    LAST_PAGE: LAST_PAGE,
    PREV_PAGE: PREV_PAGE,
    NEXT_PAGE: NEXT_PAGE,
    REFRESH: REFRESH
  };
};
var _getIcons = getIcons(),
  FIRST_PAGE = _getIcons.FIRST_PAGE,
  LAST_PAGE = _getIcons.LAST_PAGE,
  PREV_PAGE = _getIcons.PREV_PAGE,
  NEXT_PAGE = _getIcons.NEXT_PAGE,
  REFRESH = _getIcons.REFRESH;
exports.REFRESH = REFRESH;
exports.NEXT_PAGE = NEXT_PAGE;
exports.PREV_PAGE = PREV_PAGE;
exports.LAST_PAGE = LAST_PAGE;
exports.FIRST_PAGE = FIRST_PAGE;
var _default = getIcons;
exports.default = _default;